
export default class AlternatingRow {

	static getHolderSelectors = () => ['.alternating-row-element'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		const sliderElement = holderElement.querySelector('.splide');
		if (!sliderElement) {
			return;
		}


		const slider = new Splide(sliderElement, {
			type: 'loop',
			gap: '1rem',
			perPage: 1,
			perMove: 1,
			pagination: false,
			arrows: false,
		});
		slider.mount();

		const sliderControls = holderElement.querySelectorAll('[data-slider-control]');
		sliderControls.forEach(sliderControl => {
			sliderControl.addEventListener('click', () => {
				slider.go(sliderControl.dataset.sliderControl);
			});
		});
	}

}
